export function isReportPermission(permission: string) {
  return permission.split('_').includes('reports');
}
